<script>
import Modal from '@phoenix/mixins/components/common/Modal';
import ModalCloseButton from '@maison/components/common/ModalCloseButton.vue';

export default {
  components: {
    ModalCloseButton,
  },

  mixins: [Modal],

  props: {
    closeOnClickOutside: {
      type: Boolean,
      default: true,
    },
    containerClasses: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    _classes() {
      return [
        'modal',
        'micromodal-slide',
        {
          'modal--small': this.small,
          'modal--large': this.large,
          'modal--full': this.fullscreen,
          'modal--naked': this.naked,
        },
        ...this.classes,
      ];
    },

    _containerClasses() {
      return ['modal__container', ...this.containerClasses];
    },
  },
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div class="modal__overlay" tabindex="-1" :data-modal-close="closeOnClickOutside ? id : false">
      <modal-close-button v-if="closeButtonOutside" :modal-id="id" class="modal__close-button" />

      <div
        :class="_containerClasses"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="`${id}-title`"
        :data-cy="dataCy"
      >
        <header v-if="shouldDisplayHeader" :class="_headerClasses">
          <h4 :id="`${id}-title`" class="h5 modal__title" style="white-space: normal">{{ title }}</h4>

          <modal-close-button :modal-id="id" />
        </header>

        <slot name="header" />

        <main v-if="shouldWrapContent" :id="`${id}-content`" :class="_contentClasses">
          <slot name="content" />
        </main>
        <slot v-else name="content" />

        <footer v-if="hasFooterSlot" class="modal__footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </div>
</template>
